export default "__VITE_ASSET__DBYjR7FU__"